import {sources as srcGen} from './sources.js'
import settings from './settings.js'


export {
  srcGen,
  settings
}

export default {
  srcGen,
  settings
}



//////////////////
// WEBPACK FOOTER
// /data/code/gitlab/crossasia-itr-solr-setting/index.js
// module id = UfQV
// module chunks = 1